import CommercePaymentCardEmptyState from '../behaviors/commercePayment/CommercePaymentCardEmptyState';
import { CardAction, CardEmptyState, ChickletSecondaryDisplayLabels, ChickletHoverActions, CardFooterAction } from '../constants/BehaviorTypes';
import CommercePaymentCardAction from '../behaviors/commercePayment/CommercePaymentCardAction';
import getCommercePaymentChickletHoverActions from '../behaviors/commercePayment/getCommercePaymentChickletHoverActions';
import getPaymentChickletSecondaryDisplayLabels from '../behaviors/commercePayment/getPaymentChickletSecondaryDisplayLabels';
import useDefaultCardFooterAction from '../behaviors/default/useDefaultCardFooterAction';
import useEmptyCardFooterAction from '../behaviors/default/useEmptyCardFooterAction';
export const CommercePayment = {
  [CardEmptyState]: () => CommercePaymentCardEmptyState,
  [CardAction]: () => CommercePaymentCardAction,
  [ChickletSecondaryDisplayLabels]: () => getPaymentChickletSecondaryDisplayLabels,
  [ChickletHoverActions]: () => getCommercePaymentChickletHoverActions,
  [CardFooterAction]: () => args => {
    if (args.hasScope('commerce-payments-access')) {
      return useDefaultCardFooterAction(args);
    }
    return useEmptyCardFooterAction(args);
  }
};